module.exports = __webpack_public_path__ + "static/img/photo_robot.8c6ca82.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/photo/photo_robot.jpg
// module id = WWT6
// module chunks = 12